import { production } from 'app/config/constants'
import { makeAutoObservable, runInAction } from 'mobx'
import { api } from 'store/api'
import { opt } from 'store/opt'
import { ItemRecommendation } from 'type/ItemRecommendations'

const PRODUCTS = [
  '6fb117e7-db35-415a-9c6a-b68ccc39a5b7',
  '249376f4-4612-4b6a-acf5-3092bcbc815a',
  `a5142956-51bf-4f35-8a0e-ff08ed728527`,
]

function enabled(): boolean {
  return !production || PRODUCTS.includes(opt.product)
}

/**
 * Подборка грузится вместе с экраном, а не по нажатию: кнопки быть не должно, пока неизвестно,
 * есть ли что показывать — пустая модалка хуже отсутствующей кнопки.
 */
class ItemRecommendationsStore {
  private loaded: string | undefined
  private items: ItemRecommendation[] = []
  open = false

  constructor() {
    makeAutoObservable(this)
  }

  async load(item_id: string | undefined) {
    // подборки собираются только для Салариса, остальным компаниям ручка ответит пустым списком
    if (!enabled() || !opt.salaris) return
    if (!item_id || this.loaded === item_id) return
    this.loaded = item_id

    try {
      const { items } = await api.getItemRecommendations(item_id)
      runInAction(() => {
        this.items = items
      })
    } catch (e) {
      console.error('item recommendations failed', e)
      runInAction(() => {
        this.items = []
      })
    }
  }

  /** В каталоге заполнено далеко не всё: карточка без единой подписи — это одна картинка, её не показываем. */
  get visible(): ItemRecommendation[] {
    return this.items.filter(it => it.name || it.brand || it.article || it.description || it.price)
  }

  show() {
    this.open = true
  }

  hide() {
    this.open = false
  }
}

export const itemRecommendations = new ItemRecommendationsStore()
